<template>
  <v-dialog v-model="active" persistent width="500">
    <v-card>
      <v-card-title class="headline" primary-title>
        {{ title }}
      </v-card-title>
      <v-card-text v-html="text"> </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="confirm">
          {{ confirmText }}
        </v-btn>
        <v-btn
          aria-label="Ikke bekreft"
          v-if="showRejectButton"
          flat
          @click="reject"
        >
          {{ rejectText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  data: () => ({
    dialog: false,
  }),
  props: {
    active: Boolean,
    title: String,
    text: String,
    confirmText: String,
    rejectText: String,
    showRejectButton: {
      default: true,
      type: Boolean,
    },
  },
  methods: {
    emitEvent(eventName) {
      this.$emit(eventName);
    },
    confirm() {
      this.emitEvent("dialog-confirmed");
    },
    reject() {
      this.emitEvent("dialog-rejected");
    },
  },
};
</script>

<style scoped></style>
